import { IAncestor } from '../../../core/models/ancestor';

export const categoryIcon = (category: string): string => {
  switch (category) {
    case 'Material':
      return 'article';
    case 'material':
      return 'article';
    case 'Exercício':
      return 'edit';
    case 'exercise':
      return 'edit';
    case 'Videoaula':
      return 'play_circle';
    case 'lesson':
      return 'play_circle';
    case 'Audio':
      return 'mic';
    case 'podcast':
      return 'mic';
    default:
      return 'play_circle';
  }
};

export const categoryURL = (
  ancestors: IAncestor,
  slug: string,
  subject: string,
  category: string,
  obj?: any
): string => {
  if (!ancestors) {
    return '#';
  }

  switch (category) {
    case 'Material':
      return `/disciplinas/${ancestors?.area?.slug}/modulo/${ancestors?.subarea?.slug}/assunto/${subject}/material/${slug}`;
    case 'Exercício':
      return `/disciplinas/${ancestors?.area?.slug}/modulo/${ancestors?.subarea?.slug}/assunto/${subject}/exercicio/${slug}`;
    case 'Videoaula':
      return `/disciplinas/${ancestors?.area?.slug}/modulo/${ancestors?.subarea?.slug}/assunto/${subject}/videoaula/${slug}`;
    case 'Audio': {
      return `/disciplinas/${ancestors?.area?.slug}/modulo/${ancestors?.subarea?.slug}/tipo/podcast?slug=${obj.slug}`;
    }
    default:
      return '#';
  }
};
